import { render, staticRenderFns } from "./Modals.vue?vue&type=template&id=636fc0e0&scoped=true&"
import script from "./Modals.vue?vue&type=script&lang=js&"
export * from "./Modals.vue?vue&type=script&lang=js&"
import style0 from "./Modals.vue?vue&type=style&index=0&id=636fc0e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_y5o36p7qrshhm4v7l6yk7rwfsu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636fc0e0",
  null
  
)

export default component.exports